export default "__VITE_ASSET__CKNmlRSr__"